import React from "react";

import clsx from "clsx";
import { FieldValues, Path, RegisterOptions, UseFormRegister } from "react-hook-form";


interface StyledTextInputProps<T extends FieldValues> extends React.HTMLProps<HTMLInputElement> {
  register: UseFormRegister<T>;
  registerName: Path<T>;
  label?: string;
  registerOptions?: RegisterOptions<T, Path<T>>;
  colsClass?: string; // Tailwind CSS grid column classes
  classes?: string;
  labelClasses?: string;
  description?: string; // Subtext under the label for longer descriptions
  error?: string;
}

export function StyledTextInput<T extends FieldValues>({
  register,
  registerName,
  label,
  registerOptions = {},
  disabled = false,
  colsClass = "sm:col-span-1",
  classes,
  labelClasses,
  description,
  error,
  ...rest
}: StyledTextInputProps<T>) {

  const Input = () => <>
    {label && (
      <label htmlFor={registerName as string} className={clsx("mb-1 text-sm font-medium text-gray-700", labelClasses)}>
        {label}
      </label>
    )}
    <input
      {...register(registerName, registerOptions)}
      id={registerName as string}
      aria-describedby={description ? `${registerName as string}-desc` : undefined}
      disabled={disabled}
      type="text"
      className={clsx(
        disabled ? "bg-gray-300" : "",
        "mt-1 w-full block shadow-sm focus:ring-etpink-500 focus:border-etpink-500 sm:text-sm border-gray-300 rounded-md",
        error && "border-red-500", // highlight error
        classes
      )}
      {...rest}
    />
    {description && (
      <p id={`${registerName as string}-desc`} className="text-xs text-gray-500 mt-1">{description}</p>
    )}
    {error && (
      <p className="text-xs text-red-500 mt-1">{error}</p>
    )}
  </>;

  if (colsClass !== "") {
    return (
      <div className={clsx(colsClass !== "" ? colsClass : "")}>
        <Input />
      </div>
    )
  } else {
    return <Input />
  }
}